import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Dashboard from './app/Dashboard';
import Chrome from './onboarding/Chrome';
import CompleteProfile from './onboarding/CompleteProfile';
import References from './onboarding/References';
import BackgroundCheck from './onboarding/BackgroundCheck';
import PackageBuilder from './onboarding/PackageBuilder';
import FullApproval from './onboarding/FullApproval';
import Register from './auth/Register';
import Login from './auth/Login';
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import EnhancedProfile from './onboarding/EnhancedProfile';
import SetSchedule from './onboarding/complete-profile/SetSchedule';
import OnboardingRouter from './routes/OnboardingRouter';
import RootRedirect from './routes/RootRedirect';
import MeetingWaitingRoom from './components/MeetingWaitingRoom';
import MeetingView from './components/MeetingView';
import JoinSession from './components/JoinSession';
import PayoutsReturn from './pages/PayoutsReturn';
import PayoutsRefresh from './pages/PayoutsRefresh';
import TermsOfServicePage from './components/tos/TermsOfServicePage';
import StaticTermsPage from './components/tos/StaticTermsPage';
import PrivacyPolicyPage from './components/privacy/PrivacyPolicyPage';
import { GuideLandingPage } from './components/LandingPage';
import { getSupabaseClient } from './lib/supabase';
import { AuthCallback } from './auth/AuthCallback';
import { PostHogIdentify } from './components/PostHogIdentify';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function GuideLandingRoute() {
  const navigate = useNavigate();
  return (
    <GuideLandingPage
      onBeginApplication={() => navigate('/register')}
      onSignIn={() => navigate('/login')}
      onLogout={async () => {
        const supabase = getSupabaseClient();
        await supabase.auth.signOut();
        navigate('/login');
      }}
    />
  );
}

export default function App() {
  const env = (window as any).__ENV__;
  if (!env) {
    return <p>Loading environment...</p>;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <PostHogIdentify />
      <Routes>
        <Route path="/" element={<GuideLandingRoute />} />
        <Route path="/start" element={<RootRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/onboarding" element={<OnboardingRouter />} />
        <Route path="/waiting-room" element={<MeetingWaitingRoom />} />
        <Route path="/meeting" element={<MeetingView />} />
        <Route path="/join/:sessionId" element={<JoinSession />} />
        <Route path="/payouts/return" element={<PayoutsReturn />} />
        <Route path="/payouts/refresh" element={<PayoutsRefresh />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/terms/full" element={<StaticTermsPage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />

        <Route
          path="/onboarding/complete-profile"
          element={
            <Chrome stepIndex={3}>
              <CompleteProfile />
            </Chrome>
          }
        />
        <Route
          path="/onboarding/complete-profile/enhanced-profile"
          element={
            <Chrome stepIndex={3}>
              <EnhancedProfile />
            </Chrome>
          }
        />
        <Route
          path="/onboarding/complete-profile/references"
          element={
            <Chrome stepIndex={3}>
              <References />
            </Chrome>
          }
        />
        <Route
          path="/onboarding/complete-profile/background-check"
          element={
            <Chrome stepIndex={3}>
              <BackgroundCheck />
            </Chrome>
          }
        />
        <Route
          path="/onboarding/complete-profile/schedule"
          element={
            <Chrome stepIndex={3}>
              <SetSchedule />
            </Chrome>
          }
        />
        <Route
          path="/onboarding/complete-profile/packages"
          element={
            <Chrome stepIndex={3}>
              <PackageBuilder />
            </Chrome>
          }
        />
        <Route path="/onboarding/full-approval" element={<FullApproval />} />
      </Routes>
    </BrowserRouter>
  );
}
